import { getUser } from '../store/selectors/user.selector.ts';
import { store } from '../store/store.ts';

const notificationAudio = new Audio('/sounds/notification.mp3');

export function playNotificationSound(): void {
  const user = getUser(store.getState());
  if (user?.settings?.muteNotificationSound) return;

  notificationAudio.currentTime = 0;
  notificationAudio.play().catch(() => {
    // Browser may block autoplay until user interacts with the page
  });
}
